import { render, staticRenderFns } from "./AppNotificationsPopover.vue?vue&type=template&id=23fa496e&scoped=true"
import script from "./AppNotificationsPopover.vue?vue&type=script&lang=js"
export * from "./AppNotificationsPopover.vue?vue&type=script&lang=js"
import style0 from "./AppNotificationsPopover.vue?vue&type=style&index=0&id=23fa496e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa496e",
  null
  
)

export default component.exports